import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import { Privacy, Terms } from "./pages/Legal";
import Onboarding from "./pages/Onboarding";
import Chat from "./pages/Chat";
import Settings from "./pages/Settings";
import ProtectedRoute from "./components/ProtectedRoute";
import GuestOnlyRoute from "./components/GuestOnlyRoute";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./components/Toast";

function App() {
    // Toasts wrap auth: AuthProvider raises one when a session expires.
    return (
        <ToastProvider>
            <AuthProvider>
                <Router>
                    <div className="App">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            {/* Public and unauthenticated on purpose: someone
                                deciding whether to sign up needs to read these
                                first. */}
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route
                                path="/login"
                                element={
                                    <GuestOnlyRoute>
                                        <Login />
                                    </GuestOnlyRoute>
                                }
                            />
                            <Route
                                path="/register"
                                element={
                                    <GuestOnlyRoute>
                                        <Register />
                                    </GuestOnlyRoute>
                                }
                            />
                            <Route
                                path="/verify-email"
                                element={<VerifyEmail />}
                            />
                            <Route
                                path="/forgot-password"
                                element={
                                    <GuestOnlyRoute>
                                        <ForgotPassword />
                                    </GuestOnlyRoute>
                                }
                            />
                            <Route
                                path="/onboarding"
                                element={
                                    <ProtectedRoute>
                                        <Onboarding />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/app"
                                element={
                                    <ProtectedRoute>
                                        <Chat />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <Settings />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="*"
                                element={<Navigate to="/" replace />}
                            />
                        </Routes>
                    </div>
                </Router>
            </AuthProvider>
        </ToastProvider>
    );
}

export default App;
